<template>
  <router-link
    :class="{'text-access-no-permission': !checkPermissions(permission.lecture)}"
    :to="{
      name: 'detail-image-produit',
      params: { id: id, libelle: libelle }
    }"
    target="_blank">
    <b-tooltip size="is-large" position="is-right" type="is-select" :active='!!imageTooltip'>
      <img :src="src" class="imageIcon" :class="{'max-width-100 is-max-height-200px': maxSize}">
      <template v-slot:content>
        <img :src="imageTooltip" class="imageContentMateriel">
      </template>
    </b-tooltip>
  </router-link>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';

const Permissions = createNamespacedHelpers('permissions');

export default {
  name: 'image-view',
  props: {
    permission: {
      type: Object,
      required: true,
    },
    imageTooltip: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      required: true,
    },
    libelle: {
      type: String,
      required: true,
    },
    maxSize: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    src() {
      return this.image || '/static/img/default-placeholder.png';
    },
  },
};
</script>
